import { UserDetailedLog } from './../../shared/UserDetailedLog.model';
import { Component, Inject, ViewChild, OnInit, AfterViewChecked, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { LoggingService } from 'src/logs/shared/logging.service';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';

@Component({
  templateUrl: './dialog.detailedLogs.component.html',
  styleUrls: ['./dialog.detailedLogs.component.css'],
  providers: [LoggingService]
})
export class DialogDetailedLogsComponent implements OnInit, AfterViewChecked {
  logs: UserDetailedLog[] = [];
  rowColor: string = "bisque";
  displayedColumns: string[] = ['job_id', 'job_name', 'ip_address', 'created_at', 'operation_title', 'operation_request', 'operation_response', 'parent_job_id'];
  // displayedColumns: string[] = ['job_id', 'log_time', 'log_content'];
  logsTableData: MatTableDataSource<UserDetailedLog> = new MatTableDataSource([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    public dialogRef: MatDialogRef<DialogDetailedLogsComponent>,
    public loggingService: LoggingService,
    private elem: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: { jobId, IP },
    private loggerService: LoggerService
  ) { }

  ngOnInit(): void {
    this.getLogs();
  }

  ngAfterViewChecked(): void {
    //to adjust the headers of the table
    //(document.querySelector('.mat-sort-header-container') as HTMLElement).style.justifyContent='center';
    let elements = this.elem.nativeElement.querySelectorAll('.mat-sort-header-container');
    elements.forEach(element => {
      element.style.justifyContent = 'center';
    });
    elements = this.elem.nativeElement.querySelectorAll('th');
    elements.forEach(element => {
      element.style.textAlign = 'center';
      element.style.fontWeight = '800';
      element.style.color = 'black';
      element.style.padding = '2px';
      element.style.fontSize = '12px';

    });
    elements = this.elem.nativeElement.querySelectorAll('td');
    elements.forEach(element => {
      element.style.textAlign = 'center';
      element.style.padding = '2px';
      element.style.fontSize = '12px';

    });
  }

  getLogs() {
    this.loggingService.getDetailedLogs(this.data.jobId, this.data.IP).subscribe({
      next: response => {
        // let data: any = response.data
        this.logs = response.data;
        // if (this.logs.length == 0) {
        //   let emptyObject: UserDetailedLog = {
        //     job_id: "NA",
        //     log_time: "NA",
        //     log_content: "NA"
        //   };
        //   this.logs.push(emptyObject);
        // }

        this.logsTableData = new MatTableDataSource(this.logs);
        this.logsTableData.paginator = this.paginator;
        this.logsTableData.sort = this.sort;
      },
      error: err => {
        // let emptyObject: UserDetailedLog = {
        //   job_id: "NA",
        //   log_time: "NA",
        //   log_content: "NA"
        // };
        // this.logs.push(emptyObject);
        this.loggerService.log("DialogDetailedLogsComponent", err.message, Levels.error)
      }
    });
  }

  clearLogs() {
    this.logs = [];
    this.logsTableData = new MatTableDataSource(this.logs);
    this.logsTableData.paginator = this.paginator;
    this.logsTableData.sort = this.sort;
  }

  colorRow(elementData: UserDetailedLog): string {
    // if (elementData.operation_response.includes("OK")) {
    //   this.rowColor = 'limegreen';
    // } else if (elementData.operation_response.includes("ERROR")) {
    //   this.rowColor = 'red';
    // } else {
    //   this.rowColor = "white";
    // }
    return this.rowColor;
  }

  // fetchOperationResponse(elementData: UserDetailedLog): string {
  //   let response: string = "";
  //   if (elementData.operation_response.includes("OK")) {
  //     //response = 'Success';
  //     response = elementData.operation_response;
  //   } else if (elementData.operation_response.includes("ERROR")) {
  //     // response = 'Failed';
  //     response = elementData.operation_response;
  //   } else {
  //     response = 'NA';
  //   }
  //   return response;
  // }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.logsTableData.filter = filterValue.trim().toLowerCase();
    if (this.logsTableData.paginator) {
      this.logsTableData.paginator.firstPage();
    }
  }
  onClick(): void {
    this.dialogRef.close();
  }

}
